import Http from '@/utils/http/index';

export default {
  /**
 * 获取账户流水
 */
  getAccountFlow(params) {
    const newParams = Object.assign({}, params);
    if (newParams.serviceId) {
      delete newParams.beginTime;
      delete newParams.endTime;
    }
    if (newParams.businessType && newParams.businessType === 'payout') {
      newParams.businessType = 'PAYOUT';
    }
    if (newParams.businessType && newParams.businessType === 'acq') {
      newParams.businessType = 'ACQUIRING';
    }
    console.log(newParams, 'newParams');
    return Http.get('/merchant/account/listAccountRecord', { params: newParams });
  },
  /**
   * 获取账户流水下载
   */
  downloadAccountFlow(params) {
    return Http.get('/merchant/account/downloadAccountRecord', { params });
  },
};
